import { Directive, ElementRef, HostListener, Input, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Directive({
  selector: '[appMoneyMask]',
  standalone: true,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MoneyMaskDirective),
    multi: true
  }]
})
export class MoneyMaskDirective implements ControlValueAccessor {
  /** Teto opcional pro valor digitado (ex.: 100 pra campos de percentual).
   *  Sem isso o campo aceita qualquer número, o que permitia digitar coisas
   *  como 9.999.999.999,99 num campo de % Comissão. */
  @Input() appMoneyMaskMax?: number;

  private onChange: (val: number | null) => void = () => {};
  private onTouched: () => void = () => {};

  constructor(private el: ElementRef<HTMLInputElement>) {}

  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    let raw = value.replace(/\D/g, '');
    if (!raw) {
      this.el.nativeElement.value = '';
      this.onChange(null);
      return;
    }
    let num = parseInt(raw, 10) / 100;
    if (this.appMoneyMaskMax != null && num > this.appMoneyMaskMax) {
      num = this.appMoneyMaskMax;
    }
    const formatted = num.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    this.el.nativeElement.value = formatted;
    this.onChange(num);
  }

  @HostListener('blur')
  onBlur() {
    this.onTouched();
  }

  writeValue(value: any): void {
    if (value === null || value === undefined || value === '') {
      this.el.nativeElement.value = '';
    } else {
      let num = Number(value);
      if (!isNaN(num)) {
        if (this.appMoneyMaskMax != null && num > this.appMoneyMaskMax) {
          num = this.appMoneyMaskMax;
        }
        this.el.nativeElement.value = num.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      } else {
        this.el.nativeElement.value = '';
      }
    }
  }

  registerOnChange(fn: any): void { this.onChange = fn; }
  registerOnTouched(fn: any): void { this.onTouched = fn; }
  setDisabledState(isDisabled: boolean): void {
    this.el.nativeElement.disabled = isDisabled;
  }
}
